
import {
  JSSelectPicker,
  InputSelector,
} from "./base"


const default_selector = {
  scope:        ".cell-listing-filter__filter-option--no-of-bedrooms-range__wrapper",
  main:         ".js-selectpicker",
  arrow:        ".select2-selection__arrow b[role=\"presentation\"]",
  first_option: "option:nth-of-type(1)",
}


export class RoomSelectPicker extends JSSelectPicker {
  constructor(selector?: InputSelector) {
    const merged_selector = Object.assign({}, default_selector, selector)

    super(merged_selector, true)
    this.selector = merged_selector
  }

  protected onChange(val: any){
    this.triggerVisualChange()
    this.emit("val_change", val)
  }
  protected onDummyChange(){
    this.triggerVisualChange()
  }
  protected triggerVisualChange(){
    if (this.val() === this.default_option){
      this.setTextNormal()
    }
    else{
      this.setTextBold()
    }
  }
  private setTextBold(){
    this.$scope.css("font-weight", "bold")
    return this
  }
  private setTextNormal(){
    this.$scope.css("font-weight", "normal")
    return this
  }
}


const Factory = {
  create(selector?: InputSelector){
    return new RoomSelectPicker(selector)
  },
}

export {
  Factory,
}
